// copyright itestra GmbH 2016
import {
    OnInit,
    OnChanges,
    Component,
    Input,
    Output,
    ViewChild,
    EventEmitter,
    ElementRef,
    Renderer2,
    Inject,
} from "@angular/core";
import {
    UntypedFormControl,
    UntypedFormGroup,
    FormArray,
    AbstractControl,
} from "@angular/forms";
import { Observable } from "rxjs";

import { config, version } from "../site-local";
import { ValidatableComponent } from "../components/base.component";
import {
    ConsultationService,
    TrackingText,
} from "../services/consultation.service";
import { Strings } from "../app.constants";
import { Protocol, Attachment } from "../data/model";
import { ConsultationProcess } from "../data/model";
import { UserInfo } from "../data/product";
import { trackEntity } from "../utils/utils";
import { PersistenceService } from "../store/model/persistence.service";
import { KeycloakService } from "../security";
import { PromptModalComponent } from "../components/modals/prompt-modal.component";

@Component({
    selector: "attachments",
    exportAs: "attachments",
    templateUrl: "attachments.component.html",
    styles: [
        `
        a {
            cursor: pointer;
        }
        .fileInput-box {
            overflow: hidden;
            cursor: pointer;
        }
        .fileInput {
            position: absolute;
            left 0px;
            height: 40px;
            width: 200px;
            opacity: 0.001;
            cursor: pointer;
            border: 1px solid red;
            font-size: 30px;
        }
    `,
    ],
})
export class AttachmentsComponent
    extends ValidatableComponent
    implements OnInit, OnChanges
{
    public maxFileLength = config.MAX_ATTACHMENT_LENGTH
        ? config.MAX_ATTACHMENT_LENGTH
        : 10 * 1024 * 1024;
    public maxFileCount = config.MAX_ATTACHMENT_COUNT
        ? config.MAX_ATTACHMENT_COUNT
        : 10;
    @Input() public attachmentAvailable: boolean;
    protected strings = Strings;

    @Input() public attachments: Attachment[];
    @Input() public addAttachmentFun: (
        attachment: Attachment,
        content: File,
    ) => Observable<Attachment>;

    @ViewChild("fileInput") fileInput: ElementRef;

    trackEntity = trackEntity;
    removeFileExtension = removeFileExtension;

    constructor(
        private consultationService: ConsultationService,
        private renderer: Renderer2,
        private persistence: PersistenceService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.form = new UntypedFormGroup({
            FileInput: new UntypedFormControl(),
        });
        this.subscribeToFormStatusChange();
        this.consultationService.consultationProcess$.subscribe(
            (consultationProcess) => {
                this.attachmentAvailable =
                    consultationProcess.AttachmentAvailable;
            },
        );
    }

    ngOnChanges() {
        // do not remove, the occasion view will break otherwise
    }

    onFileSelected(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length == 0) {
            return;
        }

        for (let i = 0; i < fileList.length; ++i) {
            const file = fileList[i];
            const initialFileName = this.removeFileExtension(file.name);
            PromptModalComponent.open(
                "Bitte wählen Sie einen Namen für die Anlage.",
                (fileName) => this.onSetFileName(fileName, file),
                initialFileName,
            );
        }

        this.form.get("FileInput").reset();
    }

    onSetFileName(fileName: string, file) {
        const attachment = {
            Name: fileName + ".pdf",
        } as Attachment;
        this.addAttachmentFun(attachment, file);
    }

    addAttachment() {
        const event = new MouseEvent("click", { bubbles: true });
        this.fileInput.nativeElement.dispatchEvent(event);
    }

    deleteAttachment = (attachment: Attachment) => {
        this.persistence.deleteAttachment(attachment);
    };
}

function removeFileExtension(fileName) {
    return fileName.split(".").slice(0, -1).join(".");
}
